export default {
      id: "big-close-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#big-close",
      toString: function () {
        return this.url;
      }
    }